// @roc/feature-track-record-v2
// New ("from scratch") Track Record UI for crm-portal and roc-internal-portal.
// The redesigned baseball-card primitives live in this package (NOT in @roc/ui,
// which is left untouched); the MobX stores/services remain shared in
// @roc/feature-borrowers / @roc/feature-credit-background-check.
export { BorrowerTrackRecordVerification } from './trackRecordVerification/borrowerTrackRecordVerification';

// Redesigned "task" modal that will eventually replace trackRecordThirdStep.tsx.
export { TrackRecordV2 } from './trackRecordVerification/trackRecordV2';

// Re-export the redesigned baseball-card components so consumers can import the
// whole new Track Record surface from a single package.
export {
  TrackRecordLineItemV2,
  PublicTrackRecordLineItemV2,
  PropertyInformationFormLineItemV2,
} from './components/borrowerBaseballCardV2';
